import type {
  PullRequestDiscussionAction,
  PullRequestDiscussionInput,
  PullRequestEditResult,
} from "@afar-research/contracts";
import { createStore } from "zustand/vanilla";

export function createPullRequestDiscussionSession() {
  return createStore<{
    action: Extract<PullRequestDiscussionAction, { kind: "comment" | "edit-comment" | "reaction" }>;
    command: PullRequestDiscussionInput | null;
    pending: boolean;
    result: PullRequestEditResult | null;
  }>(() => ({
    action: { kind: "comment", body: "" },
    command: null,
    pending: false,
    result: null,
  }));
}
export type PullRequestDiscussionSession = ReturnType<typeof createPullRequestDiscussionSession>;
